import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { ROUTES } from '../constants/routes';
import { Roles } from '../enums/roles.enum';
import {
  authCode,
  authLogin,
  authLogout,
  authRestore,
  getOwner,
  getOwnerUpdate,
} from '../thunks/auth-thunks';
import { useRouter } from './useRouter';

const SSO_URL = process.env.REACT_APP_SSO_URL;
const SSO_CLIENT_ID = process.env.REACT_APP_SSO_CLIENT_ID;

export const useAuth = () => {
  const dispatch = useDispatch();
  const router: any = useRouter();
  const { login, user } = useSelector((state: RootStateOrAny) => state.auth);

  const isSuperAdmin = user?.data?.role === Roles.SUPER_ADMIN;
  const isOrganizationAdmin = user?.data?.role === Roles.ORGANIZATION_ADMIN;

  const handleAuthViaEmail = (credentials: Record<string, any>) => {
    dispatch(authLogin(credentials));
  };

  const handleAuthViaSSO = () => {
    const params = {
      response_type: 'one_code',
      client_id: SSO_CLIENT_ID || 'for_testing',
      redirect_uri: window.location.origin,
      scope: 'myportal',
      state: 'testState',
    };
    window.location.href = `${SSO_URL}?${new URLSearchParams(params)}`;
  };

  const handleAuthViaCode = (code: string) => {
    authCode(code)(dispatch).then(() => router.push(ROUTES.CABINET));
  };

  const handleRestoreAuth = () => {
    dispatch(authRestore());
  };

  const handleLogout = () => {
    dispatch(authLogout());
  };

  const handleGetOwner = () => {
    dispatch(getOwner());
  };
  const handleGetOwnerUpdate = () => {
    dispatch(getOwnerUpdate());
  };

  return {
    ...login,
    user,
    isSuperAdmin,
    isOrganizationAdmin,
    handleAuthViaEmail,
    handleAuthViaSSO,
    handleAuthViaCode,
    handleRestoreAuth,
    handleLogout,
    handleGetOwner,
    handleGetOwnerUpdate,
  };
};
